import { type FC } from 'react';

import { useProviderValue } from '@app/components/LeadCard/context/hooks/useProviderValue';
import { LeadCardContext } from '@app/components/LeadCard/context/LeadCardContext';
import type { LeadCardProviderProps } from '@app/components/LeadCard/context/types';

const { Provider } = LeadCardContext;

export const LeadCardProvider: FC<LeadCardProviderProps> = ({
  children,
  ...props
}) => {
  const value = useProviderValue(props);

  return <Provider value={value}>{children}</Provider>;
};
